// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"AnimalChartHistoryBlock_loadingOverlay__vuirh","loadingWrapper":"AnimalChartHistoryBlock_loadingWrapper__atSkJ"};